import { defineComponent as n, createElementBlock as r, createCommentVNode as t, openBlock as o, normalizeClass as i, toDisplayString as l } from "vue";
const a = ["href"], p = /* @__PURE__ */ n({
  __name: "HeaderItemLink",
  props: {
    link: {}
  },
  setup(s) {
    return (e, k) => e.link.show ? (o(), r("a", {
      key: 0,
      class: i(["header-item-link", { "header-item-link__cta": e.link.isButton }]),
      href: e.link.link || "#",
      rel: "noopener noreferrer",
      target: "_blank"
    }, l(e.link.title), 11, a)) : t("", !0);
  }
});
export {
  p as default
};
